import useStore from "components/ui/Context"
import { Modal } from "components/ui"
import { useRouter } from "next/router"
import { useEffect } from "react"

export default function ModalBan() {
  const router = useRouter()
  const { modalBan, setModalBan } = useStore()
  const { show, info } = modalBan

  function onClose() {
    setModalBan({
      show: false,
      info: {}
    })
  }

  useEffect(() => {
    onClose()
  }, [router])

  return (
    <Modal isOpen={show} onCancel={onClose} showIcon={false}>
      <div className="flex flex-col items-center px-10 pt-[30px] pb-8 bg-[#1A1A1A] w-[358px] max-xs:w-full max-xs:max-w-[100vw] gap-6">
        <img width={85} height={36} src="/logo/logo.png" alt="logo" />
        <div className="flex flex-col gap-2 text-center">
          <div className="font-semibold text-lg leading-6 text-[#fafaf9]">Thông báo</div>
          <div className="font-normal text-base leading-5 text-[#afafaf]">
            {info?.message || "Bạn đã bị chặn khỏi tính năng này"}
          </div>
        </div>
        <div className="flex flex-col gap-3 w-full">
          <button
            className="text-sm font-medium text-[#fafaf9] bg-[#2E2E2E] border border-[#3A3A3A] rounded-xl py-[11px]"
            onClick={onClose}
          >
            Đóng
          </button>
        </div>
      </div>
    </Modal>
  )
}
